// src/config.js
const getApiBaseUrl = () => {
  // Check if we're running in development or production
  const isDevelopment = process.env.NODE_ENV === 'development' || 
                       window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1';

  // Allow override via environment variable
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Production URLs
  const productionUrls = [
    'https://backend.velox-network.com'
  ];

  // Development URL
  const developmentUrl = 'http://localhost:5001';

  // Return appropriate URL based on environment
  if (isDevelopment) {
    console.log('🔧 Development environment detected, using:', developmentUrl);
    return developmentUrl;
  } else {
    // Try to determine which production URL to use based on current domain
    const currentHost = window.location.hostname;
    console.log('🚀 Production environment detected for host:', currentHost);
    
    // Default to the first production URL
    const apiUrl = productionUrls[0];
    console.log('🚀 Using production API URL:', apiUrl);
    return apiUrl;
  }
};

const config = {
  apiBaseUrl: getApiBaseUrl(),
  environment: process.env.NODE_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development' || 
                window.location.hostname === 'localhost' || 
                window.location.hostname === '127.0.0.1'
};

// Log configuration for debugging
console.log('🔧 Velox Network Configuration:', config);

export default config;